export const blacklistTypes = {
  FETCH_BLACKLIST_START: 'FETCH_BLACKLIST_START',
  SET_BLACKLIST: 'SET_BLACKLIST',
  LOADING_BLACKLIST: 'LOADING_BLACKLIST',
  REMOVE_USER_FROM_BLACKLIST_START: 'REMOVE_USER_FROM_BLACKLIST_START',
};
